import conversations from './sidebarItems/conversations';
import boards from './sidebarItems/boards';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import internalChat from './sidebarItems/internalChat';
import primaryMenu from './sidebarItems/primaryMenu';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    boards(accountId),
    contacts(accountId),
    reports(accountId),
    settings(accountId),
    notifications(accountId),
    internalChat(accountId),
  ],
});
